import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Icon,
  Input,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardWellnessUX = (props: any) => {
    return(
      <div
        id="CardWellnessUX-div-0"
        style={{width: "100%", padding: "10px 0px"}}>
        <div
          id="CardWellnessUX-div-1"
          style={{display: props.hideTitle?"none":"flex", alignItems: "center", justifyContent: "space-between", padding: "15px 20px", }}>
          
          <div
            id="CardWellnessUX-div-2"
            style={{fontSize: "1.15rem", fontWeight: "bold"}}>
            รายงานการใช้สิทธิ
          </div>
        </div>
        <div
          className="ui divider"
          id="CardWellnessUX-div-3"
          style={{marginTop: 0}}>
          
        </div>
        <div
          className="ui form"
          id="CardWellnessUX-div-4"
          style={{ padding: "0px 15px" }}>
          
          <Form
            id="CardWellnessUX-Form-5">
            <FormGroup
              id="CardWellnessUX-FormGroup-6">
              <FormField
                id="CardWellnessUX-FormField-7"
                inline={true}
                style={{ display: "flex", justifyContent: "space-between", border: "1px solid rgba(117, 117, 117, 0.5)", borderRadius: "6px", padding: "12px 15px", margin: "0px 10px" }}
                width={8}>
                <div
                  id="CardWellnessUX-div-9">
                  
                  <div
                    id="CardWellnessUX-div-15">
                    
                    <label
                      id="CardWellnessUX-label-18"
                      style={{ color: "#666" }}>
                      รายการใช้สิทธิทั้งหมด
                    </label>
                  </div>
                  <div
                    id="CardWellnessUX-div-16">
                    
                    <label
                      id="CardWellnessUX-label-17"
                      style={{fontSize: "1.5rem", fontWeight: "bold"}}>
                      {`${props.total || 0} รายการ`}
                    </label>
                  </div>
                </div>
                <div
                  id="CardWellnessUX-div-10"
                  style={{ display: "flex", alignItems: "center", }}>
                  
                  <div
                    id="CardWellnessUX-div-19"
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", backgroundColor: "var(--chat-bubble-color)", width: "35px", height: "35px", fontSize: "18px", color: "var(--primary-theme-color)" }}>
                    
                    <Icon
                      id="CardWellnessUX-Icon-20"
                      name="clipboard list">
                    </Icon>
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardWellnessUX-FormField-8"
                style={{ display: "flex", justifyContent: "space-between", border: "1px solid rgba(117, 117, 117, 0.5)", borderRadius: "6px", padding: "12px 15px", margin: "0px 10px" }}
                width={8}>
                <div
                  id="CardWellnessUX-div-9">
                  
                  <div
                    id="CardWellnessUX-div-15">
                    
                    <label
                      id="CardWellnessUX-label-18"
                      style={{ color: "#666" }}>
                      ยอดรวม
                    </label>
                  </div>
                  <div
                    id="CardWellnessUX-div-16">
                    
                    <label
                      id="CardWellnessUX-label-17"
                      style={{fontSize: "1.5rem", fontWeight: "bold", color: "var(--primary-theme-color)"}}>
                      {`฿ ${props.totalPrice || 0}`}
                    </label>
                  </div>
                </div>
                <div
                  id="CardWellnessUX-div-10"
                  style={{ display: "flex", alignItems: "center", }}>
                  
                  <div
                    id="CardWellnessUX-div-19"
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", backgroundColor: "var(--chat-bubble-color)", width: "35px", height: "35px", fontSize: "18px", color: "var(--primary-theme-color)" }}>
                    
                    <Icon
                      id="CardWellnessUX-Icon-20"
                      name="money bill alternate icon">
                    </Icon>
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardWellnessUX-FormGroup-6">
              <FormField
                id="CardWellnessUX-FormField-7"
                inline={true}
                style={{ display: "flex", border: "1px solid rgba(117, 117, 117, 0.5)", borderRadius: "6px", padding: "12px 15px", margin: "0px 10px" }}
                width={16}>
                <div
                  id="CardWellnessUX-div-9"
                  style={{ width: "100%" }}>
                  
                  <Form
                    id="CardWellnessUX-Form-32">
                    <FormGroup
                      id="CardWellnessUX-FormGroup-33">
                      <FormField
                        id="CardWellnessUX-FormField-34"
                        width="4">
                        <div
                          id="CardWellnessUX-div-49"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-50"
                            style={{ fontWeight: "bold" }}>
                            เลขที่รายการ
                          </label>
                          <label
                            id="CardWellnessUX-label-51"
                            style={{ color: "#666" }}>
                            (Integer)
                          </label>
                        </div>
                        <Input
                          id="CardWellnessUX-Input-44"
                          name="product_code"
                          onChange={props.onChange}
                          placeholder="เช่น 1001"
                          value={props.filterWellness?.product_code}>
                        </Input>
                      </FormField>
                      <FormField
                        id="CardWellnessUX-FormField-35"
                        width={4}>
                        <div
                          id="CardWellnessUX-div-52"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-53"
                            style={{ fontWeight: "bold" }}>
                            เลขที่ใบแจ้งหนี้
                          </label>
                          <label
                            id="CardWellnessUX-label-54"
                            style={{ color: "#666" }}>
                            (MH.)
                          </label>
                        </div>
                        <Input
                          id="CardWellnessUX-Input-45"
                          name="invoice_code"
                          onChange={props.onChange}
                          placeholder="เช่น MH2610000014"
                          value={props.filterWellness?.invoice_code}>
                        </Input>
                      </FormField>
                      <FormField
                        id="CardWellnessUX-FormField-36"
                        width={4}>
                        <div
                          id="CardWellnessUX-div-55"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-56"
                            style={{ fontWeight: "bold" }}>
                            เลขที่ใบเสร็จ
                          </label>
                          <label
                            id="CardWellnessUX-label-57"
                            style={{ color: "#666" }}>
                            (VCM... / VCS...)
                          </label>
                        </div>
                        <Input
                          id="CardWellnessUX-Input-46"
                          name="receipt_code"
                          onChange={props.onChange}
                          placeholder="เช่น VCM2610000089"
                          value={props.filterWellness?.receipt_code}>
                        </Input>
                      </FormField>
                      <FormField
                        id="CardWellnessUX-FormField-37"
                        width={2}>
                        <div
                          id="CardWellnessUX-div-55"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-56"
                            style={{ fontWeight: "bold" }}>
                            {"\u00a0"}
                          </label>
                        </div>
                        <div
                          id="CardWellnessUX-div-93">
                          {props.buttonSearch}
                        </div>
                      </FormField>
                      <FormField
                        id="CardWellnessUX-FormField-38"
                        width={2}>
                        <div
                          id="CardWellnessUX-div-55"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-56"
                            style={{ fontWeight: "bold" }}>
                            {"\u00a0"}
                          </label>
                        </div>
                        <Button
                          fluid={true}
                          id="CardWellnessUX-Button-47"
                          onClick={props.clearData}
                          style={{ backgroundColor: "#fff", border: "1px solid rgba(117, 117, 117, 0.5)",  }}>
                          ล้างค่า
                        </Button>
                      </FormField>
                    </FormGroup>
                    <FormGroup
                      id="CardWellnessUX-FormGroup-33">
                      <FormField
                        id="CardWellnessUX-FormField-34"
                        width="4">
                        <div
                          id="CardWellnessUX-div-49"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-50"
                            style={{ fontWeight: "bold" }}>
                            วันที่รับบริการ (เริ่มต้น)
                          </label>
                        </div>
                        <DateTextBox
                          id="CardWellnessUX-DateTextBox-84"
                          onChange={props.onChangeStartDate}
                          placeholder="mm /dd/yyyy"
                          value={props.filterWellness?.start_date}>
                        </DateTextBox>
                      </FormField>
                      <FormField
                        id="CardWellnessUX-FormField-35"
                        width={4}>
                        <div
                          id="CardWellnessUX-div-52"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-53"
                            style={{ fontWeight: "bold" }}>
                            วันที่รับบริการ (สิ้นสุด)
                          </label>
                        </div>
                        <DateTextBox
                          id="CardWellnessUX-DateTextBox-85"
                          onChange={props.onChangeEndDate}
                          placeholder="mm /dd/yyyy"
                          value={props.filterWellness?.end_date}>
                        </DateTextBox>
                      </FormField>
                      <FormField
                        id="CardWellnessUX-FormField-36"
                        width={4}>
                        <div
                          id="CardWellnessUX-div-55"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-56"
                            style={{ fontWeight: "bold" }}>
                            ผู้รับบริการ
                          </label>
                          <label
                            id="CardWellnessUX-label-57"
                            style={{ color: "#666" }}>
                            (ชื่อ-นาทสกุล)
                          </label>
                        </div>
                        <Input
                          id="CardWellnessUX-Input-46"
                          name="patient_name"
                          onChange={props.onChange}
                          placeholder="เช่น นายสมชาย, น.ส.วรัญญา"
                          value={props.filterWellness?.patient_name}>
                        </Input>
                      </FormField>
                      <FormField
                        id="CardWellnessUX-FormField-37"
                        width={4}>
                        <div
                          id="CardWellnessUX-div-55"
                          style={{  display: "flex", gap: "5px" }}>
                          
                          <label
                            id="CardWellnessUX-label-56"
                            style={{ fontWeight: "bold" }}>
                            {"\u00a0"}
                          </label>
                        </div>
                        <div>
                          {props.buttonDownloadExcel}
                        </div>
                      </FormField>
                    </FormGroup>
                  </Form>
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardWellnessUX-div-88">
            
            <Table
              className="--rt-tbody-overflow-y-hidden"
              data={props.reportCoverageList || []}
              headers={`เลขที่\nรายการ,เลขที่ใบแจ้งหนี้,เลขที่ใบเสร็จ,วันที่รับบริการ,สถานที่รับบริการ,ผู้รับบริการ,สิทธิการรักษา,ยอด (บาท)`}
              id="CardWellnessUX-Table-89"
              keys="product_code,invoice_code,receipt_code,service_date,division_name,patient_name,coverage_name,price"
              minRows="10"
              showPagination={false}
              style={{height: "60vh", marginTop: "1rem"}}
              widths="100,120,140,130,170,170,*,130">
            </Table>
          </div>
          <div
            id="CardWellnessUX-div-90"
            style={{ display: "flex", justifyContent: "space-between", margin: "15px 0px" }}>
            
            <div
              id="CardWellnessUX-div-91">
              {`แสดง ${((props.activePage - 1) * props.limit) + 1} ถึง ${Math.min(   props.activePage * props.limit,   props.total )} จากทั้งหมด ${props.total} รายการ`}
            </div>
            <div
              id="CardWellnessUX-div-92">
              {props.pagination}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardWellnessUX

export const screenPropsDefault = {}

/* Date Time : Fri Oct 23 2026 05:41:07 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px 0px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideTitle?\"none\":\"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"15px 20px\", }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานการใช้สิทธิ"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: 0}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 15px\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Form",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Form-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormGroup-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", border: \"1px solid rgba(117, 117, 117, 0.5)\", borderRadius: \"6px\", padding: \"12px 15px\", margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-8"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", border: \"1px solid rgba(117, 117, 117, 0.5)\", borderRadius: \"6px\", padding: \"12px 15px\", margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.total || 0} รายการ`"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-17"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.5rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการใช้สิทธิทั้งหมด"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#666\" }"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"center\", borderRadius: \"50%\", backgroundColor: \"var(--chat-bubble-color)\", width: \"35px\", height: \"35px\", fontSize: \"18px\", color: \"var(--primary-theme-color)\" }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Icon",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Icon-20"
        },
        "name": {
          "type": "value",
          "value": "clipboard list"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-9"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-15"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวม"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#666\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-16"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "`฿ ${props.totalPrice || 0}`"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-17"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.5rem\", fontWeight: \"bold\", color: \"var(--primary-theme-color)\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"center\", borderRadius: \"50%\", backgroundColor: \"var(--chat-bubble-color)\", width: \"35px\", height: \"35px\", fontSize: \"18px\", color: \"var(--primary-theme-color)\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Icon",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Icon-20"
        },
        "name": {
          "type": "value",
          "value": "money bill alternate icon"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormGroup-6"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"1px solid rgba(117, 117, 117, 0.5)\", borderRadius: \"6px\", padding: \"12px 15px\", margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Form",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Form-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormGroup-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Input",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Input-44"
        },
        "name": {
          "type": "value",
          "value": "product_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "placeholder": {
          "type": "value",
          "value": "เช่น 1001"
        },
        "value": {
          "type": "code",
          "value": "props.filterWellness?.product_code"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Input",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Input-45"
        },
        "name": {
          "type": "value",
          "value": "invoice_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "placeholder": {
          "type": "value",
          "value": "เช่น MH2610000014"
        },
        "value": {
          "type": "code",
          "value": "props.filterWellness?.invoice_code"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Input",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Input-46"
        },
        "name": {
          "type": "value",
          "value": "receipt_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "placeholder": {
          "type": "value",
          "value": "เช่น VCM2610000089"
        },
        "value": {
          "type": "code",
          "value": "props.filterWellness?.receipt_code"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Button",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างค่า"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Button-47"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearData"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"#fff\", border: \"1px solid rgba(117, 117, 117, 0.5)\",  }"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่รายการ"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-50"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "(Integer)"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-51"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#666\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบแจ้งหนี้"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "(MH.)"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-54"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#666\" }"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบเสร็จ"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "(VCM... / VCS...)"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#666\" }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormGroup-33"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รับบริการ (เริ่มต้น)"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-50"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รับบริการ (สิ้นสุด)"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้รับบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "(ชื่อ-นาทสกุล)"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#666\" }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Input",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Input-46"
        },
        "name": {
          "type": "value",
          "value": "patient_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "placeholder": {
          "type": "value",
          "value": "เช่น นายสมชาย, น.ส.วรัญญา"
        },
        "value": {
          "type": "code",
          "value": "props.filterWellness?.patient_name"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", gap: \"5px\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 84,
      "name": "DateTextBox",
      "parent": 64,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-DateTextBox-84"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "placeholder": {
          "type": "value",
          "value": "mm /dd/yyyy"
        },
        "value": {
          "type": "code",
          "value": "props.filterWellness?.start_date"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 85,
      "name": "DateTextBox",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWellnessUX-DateTextBox-85"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "placeholder": {
          "type": "value",
          "value": "mm /dd/yyyy"
        },
        "value": {
          "type": "code",
          "value": "props.filterWellness?.end_date"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-88"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 89,
      "name": "Table",
      "parent": 88,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.reportCoverageList || []"
        },
        "headers": {
          "type": "code",
          "value": "`เลขที่\\nรายการ,เลขที่ใบแจ้งหนี้,เลขที่ใบเสร็จ,วันที่รับบริการ,สถานที่รับบริการ,ผู้รับบริการ,สิทธิการรักษา,ยอด (บาท)`"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-Table-89"
        },
        "keys": {
          "type": "value",
          "value": "product_code,invoice_code,receipt_code,service_date,division_name,patient_name,coverage_name,price"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"60vh\", marginTop: \"1rem\"}"
        },
        "widths": {
          "type": "value",
          "value": "100,120,140,130,170,170,*,130"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", margin: \"15px 0px\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "`แสดง ${((props.activePage - 1) * props.limit) + 1} ถึง ${Math.min(   props.activePage * props.limit,   props.total )} จากทั้งหมด ${props.total} รายการ`"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-91"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-92"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardWellnessUX-div-93"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonDownloadExcel"
        }
      },
      "seq": 94,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardWellnessUX",
  "project": "New Project",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
